// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1747":"wiki","2113":"sponsors","4693":"rooster","6720":"veelgestelde","7947":"berichten","9613":"activiteiten"}[chunkId] + "." + {"1747":"2edab1d0","2113":"cdb46d96","4693":"cbe7501c","6720":"cdb46d96","7947":"cdb46d96","9613":"cdb46d96"}[chunkId] + ".css";
};